// extracted by mini-css-extract-plugin
export var placeholder = "xreqY";
export var shrinkable = "TNQFp";
export var underlay = "I8mqZ";